define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./role-group-actions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, RoleGroupActions) {
    "use strict";
    var RoleGroups = /** @class */ (function () {
        function RoleGroups() {
            this.filterByAny = ko.observable("");
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,Roles.Edit,Roles.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,Roles.Delete"));
            this.canExport = UserContext.hasAccess("Admin");
            this.roleGroupActions = new RoleGroupActions();
        }
        RoleGroups.prototype.init = function () {
            var self = this;
            $("#page-title").text("Roles Management");
            tools.ajaxGet({
                url: "/RoleGroup/GetListLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.lookupLists.GridStructures.RoleGroupStructure);
                    self.roleGroupActions.saveCallback = function (resultData) {
                        if (resultData) {
                            self.roleGroupsTable.refresh();
                        }
                    };
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        RoleGroups.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "140px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a title="Edit Role" class="btn btn-sm btn-yellow btn-edit"><i class="fa fa-edit "></i></a>';
                        html += '&nbsp;<a title="Duplicate Role" class="btn btn-sm btn-yellow btn-duplicate"><i class="fa fa-files-o "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button title="Delete" class="btn btn-sm btn-danger btn-remove"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.roleGroupsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/RoleGroup/GetRoleGroups",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.searchText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#role-group-toolbar-template").html()),
                    columns: columns,
                    scrollable: true
                },
                enableExport: {
                    entityName: "RoleGroup",
                    title: "Role Groups",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: "divRoleGroupTable",
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.roleGroupsTable.initGrid(gridOptions);
            $("#divRoleGroupTable tbody").on("click", ".btn-edit", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.roleGroupActions.editRoleGroup(dataItem.Id, dataItem.Name);
                event.preventDefault();
            }).on("click", ".btn-duplicate", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.roleGroupActions.editRoleGroup(dataItem.Id, dataItem.Name, true);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.roleGroupActions.deleteRoleGroupConfirm(dataItem.Id, dataItem.Name);
                event.preventDefault();
            });
            self.roleGroupActions.deleteCallback = function () {
                self.roleGroupsTable.refresh();
            };
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.roleGroupsTable.refresh();
            });
        };
        RoleGroups.prototype.editRoleGroup = function () {
            var self = this;
            self.roleGroupActions.editRoleGroup(-1);
        };
        RoleGroups.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        RoleGroups.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.roleGroupsTable.exportTo();
            }
        };
        RoleGroups.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("RoleGroup");
                dataLogs.open("Roles logs");
                event.preventDefault();
            }
        };
        return RoleGroups;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/RoleGroup/Index")) {
            log.log("Initialize RoleGroups list");
            $(function () {
                (new RoleGroups()).init();
            });
        }
    }, 0);
    return RoleGroups;
});
//# sourceMappingURL=role-groups.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/roleGroup/role-groups.js
// module id = 282
// module chunks = 2